import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, Observable, switchMap, tap, throwError } from 'rxjs';


export function JwtInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const authService = inject(AuthService);
    const currentAccessToken = inject(AuthService).currentAccessToken;
    const currentPermission = inject(AuthService).currentPermission;

    if (currentAccessToken && currentPermission) {
        req = req.clone({
            setHeaders: {
                'Authorization': `Bearer ${currentAccessToken}`,
                'X-Permission': currentPermission
            }
        });
    }
    return next(req).pipe(
        tap(event => {
            if (event.type === HttpEventType.Response) {
                console.log(req.url, 'response return status', event.status);
            }            
        }),       
        catchError((err) => {
            if (err.status === HttpStatusCode.Unauthorized) {
                return authService.refreshToken().pipe(
                    switchMap(() => {
                        const newReq = req.clone({
                            setHeaders: {
                                'Authorization': `Bearer ${authService.currentAccessToken}`,
                                'X-Permission': `${authService.currentPermission}`
                            }
                        });
                        return next(newReq);
                    }),
                    catchError((refreshError) => {
                        console.error('Error al refrescar el token', refreshError);
                        return throwError(() => new Error(refreshError));
                    })
                );
            }
            return throwError(() => new Error(err));
        })
    );
}